var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('NiceButton',{class:{
    'is-spinning': _vm.isSectionCurrentlyRewritingWithAi
  },attrs:{"disabled":_vm.isSectionCurrentlyRewritingWithAi,"left-icon":_vm.isSectionCurrentlyRewritingWithAi
      ? 'CircleNotchSolidIcon'
      : 'SparklesIconSolid',"color":"gray","expanded":"true"},on:{"click":_vm.openSectionRewrite}},[_vm._v(" "+_vm._s(_vm.isSectionCurrentlyRewritingWithAi ? "Rewriting with AI..." : "Edit with AI")+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }